import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';

export default function Partner() {
  const { t } = useLang();

  const scroll = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="partner" data-testid="partner-section" className="relative border-t border-[#27272A] overflow-hidden">
      {/* Red band */}
      <div className="bg-[#C8102E] text-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <Reveal className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/80">{t('partner.index')}</Reveal>
            <Reveal as="h2" className="h-section mt-4 text-white reveal-delay-1">
              {t('partner.title')}
            </Reveal>
            <Reveal className="mt-6 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed reveal-delay-2">
              {t('partner.sub')}
            </Reveal>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Reveal className="reveal-delay-3 inline-block">
              <button
                data-testid="partner-cta-button"
                onClick={scroll}
                className="inline-flex items-center gap-3 bg-[#0A0A0B] text-white px-8 py-4 font-mono text-[12px] tracking-[0.22em] uppercase border border-[#0A0A0B] hover:bg-white hover:text-[#0A0A0B] transition-colors"
              >
                {t('partner.cta')}
                <ArrowRight size={16} />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
